import { render, staticRenderFns } from "./LiveClassItem.vue?vue&type=template&id=06b12260&scoped=true"
import script from "./LiveClassItem.vue?vue&type=script&lang=js"
export * from "./LiveClassItem.vue?vue&type=script&lang=js"
import style0 from "./LiveClassItem.vue?vue&type=style&index=0&id=06b12260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b12260",
  null
  
)

export default component.exports